module.exports = __webpack_public_path__ + "img/user.1da0e569.png";